module.exports = __webpack_public_path__ + "img/p01@3x.aed8bbdb.png";